import * as React from 'react';
import { observer } from 'mobx-react';
import { DemandPageStore } from './DemandPageStore';
import { LoaderBox } from '../../components/LoaderBox';
import { Button, Col, Row, Layout, Affix } from 'antd';
import { CurrentCampaignTitle } from '../../components/CurrentCampaignTitle';
import { FilterOutlined } from '@ant-design/icons';
import { DemandTable } from './DemandTable';
import { DemandTools } from './DemandTools';
import { DemandAddNewLine } from './DemandAddNewLine';
import { DemandAddNewLinePreviousYear } from './DemandAddNewLinePreviousYear';
import { DemandFilterForm } from './DemandFilterForm';

const pageStore = new DemandPageStore();

export const DemandPage: React.FC = observer(() => {
  React.useEffect(() => {
    pageStore.init();
  }, []);

  return (
    <LoaderBox store={pageStore}>
      <Row align='middle'>
        <Col flex='auto'>
          <h1>
            Demand collection <CurrentCampaignTitle />
          </h1>
        </Col>
        <Col>
          <DemandTools store={pageStore} />
          <Button
            onClick={() => pageStore.toggleFilter()}
            icon={<FilterOutlined />}
            title='Filters'
            type={pageStore.isFilterUsed ? 'primary' : 'default'}
          />
        </Col>
      </Row>
      <Layout>
        <Layout.Content>
          <DemandTable store={pageStore} />
        </Layout.Content>
        <Affix>
          <Layout.Sider
            collapsible
            collapsedWidth={0}
            trigger={null}
            collapsed={!pageStore.isFilterOpen}
            width={300}
          >
            <DemandFilterForm store={pageStore} />
          </Layout.Sider>
        </Affix>
      </Layout>
      <DemandAddNewLine store={pageStore} />
      <DemandAddNewLinePreviousYear store={pageStore} />
    </LoaderBox>
  );
});
